import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartId: localStorage.getItem("cartId") || null,
  totalQuantity: 0,
  items: [],
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    initCart: (state, action) => {
      state.cartId = action.payload.cartId;
      state.totalQuantity = 0;
      state.items = [];
      localStorage.setItem("cartId", action.payload.cartId);
    },
    updateCart: (state, action) => {
      if (action.payload.cartId) {
        state.cartId = action.payload.cartId;
        localStorage.setItem("cartId", action.payload.cartId);
      }
      if (action.payload.totalQuantity !== undefined) {
        state.totalQuantity = action.payload.totalQuantity;
      }
      if (action.payload.items) {
        state.items = action.payload.items;
      }
    },
    clearCart: (state) => {
      state.cartId = null;
      state.totalQuantity = 0;
      state.items = [];
      localStorage.removeItem("cartId");
    },
  },
});

export const { initCart, updateCart, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
